import {useContext} from 'react';
import {SideBarContext} from '../Components';

export const useSideBarContext = () => useContext(SideBarContext);
